'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

let _ = t => t,
    _t;

import { createProductConfig } from 'pricing-pages-lib/utils/productConfigUtils';
import breakpoint from 'pricing-pages-unified-ui/utils/responsiveBreakpoints';
import { FIRST_FULL_TIME_MIGRATION } from 'self-service-api/constants/ProductNames';
import { TALK_TO_SALES } from 'ui-addon-upgrades/_core/purchaseMotions/PurchaseMotionTypes';
import Small from 'UIComponents/elements/Small';
import UIGrid from 'UIComponents/grid/UIGrid';
import UIGridItem from 'UIComponents/grid/UIGridItem';
import styled from 'styled-components';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIImage from 'UIComponents/image/UIImage';
import MigrationsBlob from 'bender-url!pricing-pages-unified-ui/img/migrations-blob.jpg';
import CodeSplitEnvWrapper from 'pricing-pages-unified-ui/components/CodeSplitEnvWrapper';
import Hubs from 'self-service-api/constants/Hubs';
import { MIGRATE_YOUR_SITE } from 'pricing-pages-unified-ui/constants/Tracking';
import SkeletonLoadWrapper from 'pricing-pages-unified-ui/components/loading/SkeletonLoadWrapper';
import { hasPricingAndPurchasingSucceededSelector } from 'pricing-pages-unified-ui/selectors/LoadingStateSelectors';
import { useSelector } from 'react-redux';
import ChecklistItem from 'pricing-pages-unified-ui/components/common/ChecklistItem';
import { currentSkuIdForProductSelector } from '../../selectors/ProductsSelectors';
const Title = styled(Small).withConfig({
  displayName: "MigrateYourSite__Title",
  componentId: "b759am-0"
})(["text-transform:uppercase;font-weight:500;"]);
const Subtitle = styled.h1.withConfig({
  displayName: "MigrateYourSite__Subtitle",
  componentId: "b759am-1"
})(["font-weight:bold;line-height:44px;", ";"], breakpoint.phone(_t || (_t = _`
    font-size: 30px;
  `)));
const MigrationImageWrapper = styled(UIGridItem).withConfig({
  displayName: "MigrateYourSite__MigrationImageWrapper",
  componentId: "b759am-2"
})(["@media (max-width:767px){display:none;}"]);
const FeaturesGrid = styled.div.withConfig({
  displayName: "MigrateYourSite__FeaturesGrid",
  componentId: "b759am-3"
})(["display:grid;grid-template-columns:1fr 1fr;"]);
const CtaWrapper = styled.div.withConfig({
  displayName: "MigrateYourSite__CtaWrapper",
  componentId: "b759am-4"
})(["&:not(:empty){margin-top:32px;}"]);

const MigrateYourSite = () => {
  const hasPricingAndPurchasingSucceeded = useSelector(hasPricingAndPurchasingSucceededSelector);
  const migrateSkuId = useSelector(state => currentSkuIdForProductSelector(state, {
    apiName: FIRST_FULL_TIME_MIGRATION
  }));
  return /*#__PURE__*/_jsxs(UIGrid, {
    children: [/*#__PURE__*/_jsxs(UIGridItem, {
      size: {
        xs: 12,
        md: 7
      },
      className: "flex-column justify-center",
      children: [/*#__PURE__*/_jsx(Title, {
        use: "help",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "websiteMigration.title"
        })
      }), /*#__PURE__*/_jsx(Subtitle, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "websiteMigration.subtitle"
        })
      }), /*#__PURE__*/_jsx("div", {
        className: "m-bottom-4",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "websiteMigration.description"
        })
      }), /*#__PURE__*/_jsxs(FeaturesGrid, {
        children: [/*#__PURE__*/_jsx(ChecklistItem, {
          message: "websiteMigration.templateSetup",
          className: "m-y-1"
        }), /*#__PURE__*/_jsx(ChecklistItem, {
          message: "websiteMigration.websiteMigration",
          className: "m-y-1"
        }), /*#__PURE__*/_jsx(ChecklistItem, {
          message: "websiteMigration.blogMigration",
          className: "m-y-1"
        }), /*#__PURE__*/_jsx(ChecklistItem, {
          message: "websiteMigration.emailTemplateRebuilding",
          className: "m-y-1"
        })]
      }), /*#__PURE__*/_jsx(CtaWrapper, {
        children: /*#__PURE__*/_jsx(SkeletonLoadWrapper, {
          height: 40,
          width: 127,
          isLoading: !hasPricingAndPurchasingSucceeded,
          children: /*#__PURE__*/_jsx(CodeSplitEnvWrapper, {
            authedComponentLoader: () => import(
            /* webpackChunkName: "authed-chunk" */
            `pricing-pages-unified-ui/components/common/HubAuthedTtsButton`),
            publicComponentLoader: () => import(
            /* webpackChunkName: "public-chunk" */
            `pricing-pages-unified-ui/components/public-only/PublicPurchaseMotionButton`),
            authedComponentProps: {
              hub: Hubs.HUB_CMS,
              location: MIGRATE_YOUR_SITE,
              productConfigurations: [createProductConfig({
                skuId: migrateSkuId
              })]
            },
            publicComponentProps: {
              sourceId: 'pricing-middle',
              productConfigurations: [createProductConfig({
                skuId: migrateSkuId
              })],
              purchaseMotions: [TALK_TO_SALES]
            }
          })
        })
      })]
    }), /*#__PURE__*/_jsx(MigrationImageWrapper, {
      size: {
        xs: 0,
        md: 5
      },
      children: /*#__PURE__*/_jsx(UIImage, {
        src: MigrationsBlob,
        loading: "lazy"
      })
    })]
  });
};

export default MigrateYourSite;